import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class IndicadorCargaComponent extends Vue {
  @Prop({ required: true })
  mensaje: string;
}
